export function QuizAssessmentTestGradeComponent({
  totalQuestions,
  correctAnswers,
}) {
  if (typeof correctAnswers === 'undefined') return null;
  const percent = new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    maximumFractionDigits: 2
  }).format(correctAnswers / totalQuestions)

  return <>{percent}</>
}